import { render, staticRenderFns } from "./recive.vue?vue&type=template&id=3d90c7bd&scoped=true&"
import script from "./recive.vue?vue&type=script&lang=js&"
export * from "./recive.vue?vue&type=script&lang=js&"
import style0 from "./recive.vue?vue&type=style&index=0&id=3d90c7bd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d90c7bd",
  null
  
)

export default component.exports